<ng-container *ngIf="costUnitGroupState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{ "app.dialog.cost-unit-group-cost-unit-assignments.title.header" | translate :{costUnitGroupName: state.selectedCostUnitGroup.name} }}
    </h1>
    <div mat-dialog-content>
        <div class="cost-unit-selection">
            <mat-generic-input
                [fields]="layout.selectFields"
                (inputFormGroupChange)="formGroupChange($event)"
            [initialValue]="{selectedCostUnits: data.assignedCostUnits}">
            </mat-generic-input>
            <button mat-mini-fab
                    color="primary"
                    [disabled]="!(costUnitSelected | async)"
                    (click)="assignCostUnit()">
                <mat-icon>save</mat-icon>
            </button>
        </div>

    </div>
    <mat-progress-bar color="accent" [style.visibility]="state.isLoadingAssignedCostUnits ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>

    <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.cost-unit.name.label" | translate }}</th>
            <td mat-cell *matCellDef="let element">
                {{element.name}}
            </td>
        </ng-container>

        <ng-container matColumnDef="articleNr">
            <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.cost-unit.articleNr.label" | translate }}</th>
            <td mat-cell *matCellDef="let element">
                {{element.articleNr}}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="layout.columns"></tr>
        <tr mat-row *matRowDef="let row; columns: layout.columns;"></tr>
    </table>
    <mat-paginator [pageSize]="10"></mat-paginator>
    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.cancel.label" | translate }}</button>
    </div>
</ng-container>
